export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-950">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-3">
              APP下载
            </h2>
            <p className="text-sm text-background-300 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              下载网红爆料APP，随时随地掌握最新网红内幕实锤解说。
              推送提醒不遗漏任何大瓜，离线缓存畅享高清吃瓜体验。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="inline-flex items-center gap-2 px-5 py-3 bg-background-50 hover:bg-background-100 text-foreground-900 font-medium rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-apple-fill text-lg"></i>
                </div>
                iOS 版本下载
              </button>
              <button className="inline-flex items-center gap-2 px-5 py-3 bg-background-50 hover:bg-background-100 text-foreground-900 font-medium rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-android-fill text-lg"></i>
                </div>
                Android 版本下载
              </button>
            </div>
            <p className="text-xs text-background-500 mt-3">支持 iOS 15+ 和 Android 8.0+ 系统</p>
          </div>
          <div className="flex-1 max-w-sm lg:max-w-none">
            <div className="relative">
              <div className="w-64 h-[420px] mx-auto rounded-3xl border-4 border-background-700 overflow-hidden bg-background-800 shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=dark%20theme%20mobile%20news%20feed%20app%20screen%20with%20trending%20topics%20and%20breaking%20news%20cards%20warm%20red%20accent%20colors%20clean%20modern%20UI%20design%20content%20feed%20layout&width=340&height=640&seq=app-screen-mock&orientation=portrait"
                  alt="网红爆料APP界面预览"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -top-3 -right-3 w-16 h-16 flex items-center justify-center rounded-full bg-accent-500">
                <div className="text-center">
                  <div className="text-xs font-bold text-background-50 leading-tight">免 费</div>
                  <div className="text-[10px] text-background-50/80">下载</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}